
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference/components/rating-component",
      function () {
        return require("private-next-pages/reference/components/rating-component.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference/components/rating-component"])
      });
    }
  